export default __webpack_public_path__ + "files/1c5c889a1530329dd883c1825942216f.jpg";